<template>
  <base-modal
    ref="$modal"
    close-by-click-outside
    fullscreen-on-mobile
    :loading="isLoading"
    @on-close="closeBaseModal"
    width="900px"
    height="800px"
  >
    <app-tabs-old ref="$tabs" :tabs="tabs" v-model="activeTab">
      <template #info>
        <div v-if="!isLoading" class="file-info">
          <div class="file-info__header">
            <div class="file-info__header-left">
              <div class="file-info__field">
                <span class="file-info__field-name">{{ $t("file_info_name") }}: </span>
                <file-input
                  ref="inputRef"
                  v-model="fileInfo.Name"
                  type="file"
                  @focus="onNameFocus"
                  @enter="rename"
                  @blur="blurInput"
                />
                <app-icon
                  v-if="
                    typeModalInfo !== 'parentFolder' &&
                    effectiveRuleAccess === 2
                  "
                  style="margin-left: 4px; margin-bottom: 2px"
                  class="file-item__option-icons-icon"
                  name="edit-pencil"
                  width="16px"
                  color="#979797"
                  cursor="pointer"
                  hover-color="#499259"
                  @click="editName"
                />
              </div>
              <div class="file-info__field">
                <span class="file-info__field-name">{{ $t("file_info_size") }}: </span>
                <span class="file-info__field-value">{{
                  typeModalInfo == "file"
                    ? fileInfo?.Size
                    : fileInfo?.SizeDisplay
                }}</span>
              </div>
              <div class="file-info__field">
                <span class="file-info__field-name"
                  >{{ $t("file_info_added") }}:
                </span>
                <span class="file-info__field-value">{{ createDate }}</span>
              </div>
              <div
                class="file-info__field"
                v-if="fileInfo?.Tags && fileInfo?.Tags.length > 0"
              >
                <span class="file-info__field-name">{{ $t("file_info_tags") }}: </span>
                <app-hashtag
                  :items="fileInfo?.Tags"
                  :selector-enabled="false"
                  type="text"
                />
              </div>
              <div class="file-info__field">
                <span class="file-info__field-name"
                  >{{ $t("file_info_download_count") }}:
                </span>
                <span class="file-info__field-value">{{
                  fileInfo?.DownloadCount
                }}</span>
              </div>
              <div
                v-if="fileInfo?.Changelog?.length"
                class="file-info__field file-info__field--col"
              >
                <div
                  class="file-info__field-name"
                  :style="{ color: '#4D4D4D' }"
                >
                  {{
                    $t(typeModalInfo == "file"
                      ? "file_info_file_changes"
                      : "file_info_folder_changes")
                  }}
                </div>
                <div
                  v-for="(change, index) in showAllChanges
                    ? fileInfo.Changelog
                    : fileInfo.Changelog.slice(0, 4)"
                  class="file-info__field-value-col"
                  :key="change.Time"
                >
                  <span class="file-info__field-value-col-time"
                    >{{ getDate(change.Time) }}&nbsp;</span
                  >
                  <span class="file-info__field-value-col-name"
                    >[{{ change.Changer }}]</span
                  >
                  <span class="file-info__field-value-col-action">
                    <template
                      v-for="(segment, segmentIndex) in formatChangelogText(change.Text)"
                      :key="segmentIndex"
                    >
                      <em v-if="segment.italic">{{ segment.text }}</em>
                      <span v-else>{{ segment.text }}</span>
                    </template>
                  </span>
                  <div
                    v-if="
                      !showAllChanges &&
                      fileInfo.Changelog.length > 4 &&
                      index === 3
                    "
                    class="file-info__field-value-col-show-more"
                    @click="showAllChanges = true"
                  >
                    {{ $t("permissions_more") }} {{ fileInfo.Changelog.length - 4 }}
                  </div>
                </div>
              </div>
            </div>
            <div class="file-info__header-right" v-if="typeModalInfo == 'file'">
              <div class="file-info__add-lists">
                <app-resizable-dropdown
                  position="left"
                  :resizable="false"
                  :initial-width="320"
                  :initial-height="436"
                  :close-by-click-outside="false"
                  :content-z-index="10003"
                  :mobile-title="$t('choose_lists')"
                  ref="$createEditFileModal"
                  name="$createFileModal"
                  @close="showAddListSelect = false"
                >
                  <template #activator>
                    <app-tooltip :text="$t('file_info_add_to_list')">
                      <template #activator>
                        <app-icon
                          class="file-info__add-lists-btn"
                          name="plus"
                          width="14px"
                          color="#979797"
                          hover-color="#499259"
                          cursor="pointer"
                          @click="showAddListSelect = true"
                        />
                      </template>
                    </app-tooltip>
                  </template>
                  <file-info-list-select
                    :file-id="fileInfo?.Id"
                    :added-lists="fileInfo?.AnalyticsLists"
                    show-close-icon
                    @close="closeAddClientDropdown"
                    @add-list="updateAnalyticLists"
                  />
                </app-resizable-dropdown>
                <div class="file-info__add-lists-text">{{ $t("file_info_lists") }}:</div>
              </div>
              <div class="file-info__lists">
                <div
                  v-for="list in fileInfo?.AnalyticsLists"
                  class="file-info__lists-item"
                  :key="list.Id"
                >
                  <div class="file-info__lists-item-name">
                    {{ list.Name }}
                  </div>
                  <app-icon
                    class="file-info__lists-item-delete"
                    name="close"
                    width="12px"
                    color="#D2D2D2"
                    hover-color="#499259"
                    cursor="pointer"
                    @click="onDeleteList(list)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #permitions>
        <file-permitions-tab
          :file-info="filePermitionsInfo"
          :rule-access="effectiveRuleAccess"
          :entity-id="fileInfo?.Id"
          :client-id="clientId"
          :project-id="projectId"
          :is-folder="typeModalInfo !== 'file'"
          @save="save"
          @open-dropdown="openDropdown"
          @close-dropdown="closeDropdown"
        />
      </template>
      <template #additionalContent>
        <div class="file-info__header-permition" v-if="hasLimitedAccess">
          <app-icon
            class="file-info__header-permition-icon"
            name="invalid"
            width="16px"
            color="#979797"
          />
          <div class="file-info__header-permition-label">
            {{ $t(typeModalInfo == 'file' ? 'file_limited_access_file' : 'file_limited_access_folder') }}
          </div>
        </div>
      </template>
    </app-tabs-old>
  </base-modal>
</template>

<script setup lang="ts">
import BaseModal from "@/components/common/modal/BaseModal.vue";
import {
  computed,
  inject,
  nextTick,
  ref,
  watch,
} from "vue";
import { AnalyticsListItem} from "@/store/clients";
import moment from "moment";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import { AnalyticsApi } from "@/ api/AnalyticsApi";
import FileInfoListSelect from "../FileInfoListSelect.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import {
  FileInfoContainer,
  FolderInfoContainer,
  TagSignable,
} from "@/models/interfaces/file/file-model";
import AppTabsOld from "@/components/ui-kit/tabs/AppTabsOld.vue";
import { useModalEscape } from "@/composables/useModalEscape";
import FileInput from "../FileInput.vue";
import FilePermitionsTab from "../permitions/FilePermitionsTab.vue";
import AppHashtag from "@/components/ui-kit/hashtag/AppHashtag.vue";
import { i18n } from "@/i18n";
import { formatChangelogText } from "@/utils/textHelpers";

type Props = {
  ruleAccess: number;
  clientId: number;
  projectId: number;
};

const props = withDefaults(defineProps<Props>(), {
  ruleAccess: 0,
  clientId: 0,
  projectId: 0,
});

const $modal = ref<typeof BaseModal | null>(null);
const isLoading = ref(false);
const fileInfo = ref<FileInfoContainer | FolderInfoContainer | null>(null);
const filePermitionsInfo = ref<FileInfoContainer | FolderInfoContainer | null>(null);
const parentFolder = ref();
const showAllChanges = ref(false);
const showAddListSelect = ref(false);
const lists = ref<AnalyticsListItem[]>([]);
const typeModalInfo = ref();
const isAdmin = inject("isAdmin");
const entityEditable = ref(false);
const effectiveRuleAccess = computed(
  () => entityEditable.value ? 2 : isAdmin? 2: 0,
);
const hasLimitedAccess = computed(() => effectiveRuleAccess.value == 0);
let tabs = [
  { id: 0, title: String(i18n.global.t("file_folder_information")), slotName: "info" },
  { id: 1, title: String(i18n.global.t("file_access_rights")), slotName: "permitions" },
];
let isNameEditable = ref(false);
const $createEditFileModal = ref<typeof AppResizableDropdown | null>(null);
const $tabs = ref<InstanceType<typeof AppTabsOld> | null>(null);
const $content = computed<HTMLElement | null>(() => ($tabs.value?.$el as HTMLElement | null) ?? null);
const isDropdownOpened = ref(false);

const closeAddClientDropdown = () => {
  $createEditFileModal.value?.close();
};

const editName = () => {
  if (effectiveRuleAccess.value !== 2) return;

  isNameEditable.value = true;

  if (inputRef.value) {
    inputRef.value.focus();
  }
};

const onNameFocus = () => {
  if (effectiveRuleAccess.value === 2) {
    isNameEditable.value = true;
  }
};

const openDropdown = () => {
  isDropdownOpened.value = true;
};

const closeDropdown = () => {
  isDropdownOpened.value = false;
};

const save = () => {
  $modal.value?.onClose();
};

const blurInput = () => {
  isNameEditable.value = false;
};

const cancelEdit = async () => {
  isNameEditable.value = false;

  inputRef.value?.blur();

  await nextTick(() => {});
};

const closeList = async () => {
  showAddListSelect.value = false;

  $createEditFileModal.value?.close();

  await nextTick(() => {});
};

const { activate: activateEsc, deactivate: deactivateEsc } = useModalEscape({
  content: $content,
  close: () => $modal.value?.onClose(),
  intercept: () => {
    // Правка имени: Escape отменяет её, окно остаётся открытым.
    if (isNameEditable.value) {
      cancelEdit();
      return true;
    }
    // Селект списков: закрываем только его.
    if (showAddListSelect.value) {
      closeList();
      return true;
    }

    if (isDropdownOpened.value) {
      return true;
    }
    return false;
  }
});

const closeBaseModal = () => {
  deactivateEsc();
};

const activeTab = ref(tabs[0].id);
const inputRef = ref<InstanceType<typeof FileInput> | null>(null);

interface ChildEventData {
  type: string;
  data: any;
}

const emitToParent =
  inject<(eventData: ChildEventData) => void>("childEventEmitter");

const createDate = computed(() => {
  if (!fileInfo.value || !fileInfo.value.CreateTime) {
    return "";
  }

  return `${moment(fileInfo.value.CreateTime).format("HH:mm DD.MM.YYYY")}${
    fileInfo.value.Creator ? ` [${fileInfo.value.Creator}]` : ""
  }`;
});

const rename = (name: string) => {
  if (emitToParent) {
    if (typeModalInfo.value === "file") {
      emitToParent({
        type: "renameFile",
        data: {
          dir: parentFolder.value,
          file: fileInfo.value?.Id,
          value: name,
          info: true,
        },
      });
    }
    if (
      typeModalInfo.value === "folder" ||
      typeModalInfo.value === "parentFolder"
    ) {
      emitToParent({
        type: "rename",
        data: { dir: fileInfo.value?.Id, value: name, info: true },
      });
    }
  }
};

const getDate = (date: string) => {
  return moment(date).format("HH:mm DD.MM.YYYY");
};

const updateAnalyticLists = async () => {
  if (!fileInfo.value) return;

  fileInfo.value.AnalyticsLists = (
    await AnalyticsApi.getListOfElement(fileInfo.value.Id, 4)
  ).Lists;
};

const onDeleteList = async (list: AnalyticsListItem) => {
  if (!fileInfo.value) return;
  await AnalyticsApi.removeElementIntoList(list.Id, 4, fileInfo?.value?.Id);
  fileInfo.value.AnalyticsLists.splice(
    fileInfo.value?.AnalyticsLists.findIndex(
      (listFile) => listFile.Id === list.Id,
    ),
    1,
  );
};

const onOpen = async (
  container: FileInfoContainer | FolderInfoContainer,
  type: string,
  parentFolderId?: number,
  tags?: TagSignable[],
  editable?: boolean,
) => {
  try {
    isLoading.value = true;
    $modal.value?.onOpen();
    activateEsc();
    typeModalInfo.value = type;
    const containerEditable = (
      container as (FileInfoContainer | FolderInfoContainer) & {
        Editable?: boolean;
      }
    ).Editable;
    entityEditable.value = editable ?? containerEditable === true;
    fileInfo.value = container;
    filePermitionsInfo.value = {
      ...container,
      Changelog: [...container.GroupChanges].sort(
        (a, b) => new Date(b.Time).getTime() - new Date(a.Time).getTime(),
      ),
    };
    if (type === "file") {
      parentFolder.value = parentFolderId;
      fileInfo.value.Changelog = fileInfo.value.FileChanges.concat(
        fileInfo.value.TagChanges
      ).sort((a, b) => new Date(b.Time).getTime() - new Date(a.Time).getTime());

      fileInfo.value.AnalyticsLists = (
        await AnalyticsApi.getListOfElement(fileInfo.value.Id, 4)
      ).Lists;

      tabs = [
        { id: 0, title: String(i18n.global.t("file_information")), slotName: "info" },
        { id: 1, title: String(i18n.global.t("file_access_rights")), slotName: "permitions" },
      ];
    } else {
      fileInfo.value.Changelog = fileInfo.value.FolderChanges.concat(
        fileInfo.value.TagChanges
      ).sort((a, b) => new Date(b.Time).getTime() - new Date(a.Time).getTime());

      tabs = [
        { id: 0, title: String(i18n.global.t("file_folder_information")), slotName: "info" },
        { id: 1, title: String(i18n.global.t("file_access_rights")), slotName: "permitions" },
      ];
    }

    if (tags) fileInfo.value.Tags = tags;
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

watch(showAddListSelect, async () => {
  const list = await AnalyticsApi.getLists(
    "",
    0,
    4,
    fileInfo.value?.Id as number,
  );

  lists.value = list.Lists;
});

defineExpose({ onOpen });
</script>

<style scoped lang="scss">
@import "@/styles/color.scss";

.file-info {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px 16px;

  &__header {
    display: flex;
    width: 100%;
    gap: 8px;

    &-permition {
      display: flex;
      flex-direction: row;
      gap: 4px;

      &-label {
        color: $color-text-secondary;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
      }
    }

    &-left,
    &-right {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    &-left {
      flex: 2;
    }

    &-right {
      flex: 1;
    }
  }

  &__field {
    margin-bottom: 4px;
    font-size: 14px;
    line-height: 18px;
    max-width: 570px;
    overflow-wrap: anywhere;
    word-break: break-word;

    &--col {
      display: flex;
      flex-direction: column;
      overflow-wrap: anywhere;
      word-break: break-word;
    }

    &-name {
      color: $color-text_main;
      font-weight: 500;
      overflow-wrap: anywhere;
      word-break: break-word;
    }

    &-value {
      color: $color-text_main;
      overflow-wrap: anywhere;
      word-break: break-word;
    }

    &-value-col {
      display: inline-block;
      align-items: center;
      overflow-wrap: anywhere;
      word-break: break-word;

      &-time {
        color: #979797;
      }

      &-name {
        color: $color-text_main;
      }

      &-action {
        margin-left: 2px;
        color: $color-text_main;
      }

      &-show-more {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
        font-size: 12px;
        line-height: 16px;
        border-radius: 8px;
        margin-left: 6px;
        margin-top: 1px;
        background-color: #F2F2F2;
        color: #979797;
        cursor: pointer;

        &:hover {
          background-color: #F3F8F4;
          color: #438451;
        }
      }

      &-link {
        font-size: 14px;
        line-height: 16px;
        color: #499259;
        text-decoration: none;
        margin-bottom: 4px;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  &__add-lists {
    display: flex;
    align-items: center;
    gap: 6px;

    &-text {
      font-size: 14px;
      line-height: 18px;
      font-weight: 500;
      color: $color-text_main;
    }

    &-btn {
      margin-top: -2px;
    }
  }

  &__lists {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 2px;
    max-width: 290px;

    &-item {
      display: inline;
      align-items: center;
      font-size: 14px;
      line-height: 18px;
      color: #333;
      overflow-wrap: anywhere;
      word-break: break-word;

      &-dot {
        height: 1px;
        width: 1px;
        border-radius: 100%;
      }

      &-name {
        display: inline;
        color: $color-text_main;
        font-size: 14px;
        line-height: 18px;
      }

      &-delete {
        margin-left: 2px;
      }
    }
  }
}
</style>
